import { gql } from '@apollo/client'
import { USER_FIELDS, COMPANY_FIELDS } from '../fragments'

export const BROADSIGN_CREATIONS = gql`
  ${USER_FIELDS}
  ${COMPANY_FIELDS}
  query BroadsignCreations($filters: BroadsignCreationFilters, $first: Int, $last: Int) {
    broadsignCreations(filters: $filters, first: $first, last: $last) {
      nodes {
        id
        broadsignId
        mediaFormat
        createdAt
        frameFormat
        duration
        status
        width
        height
        details
        usedBuildingsNotSentCount
        file {
          filename
          url
          isVideo
          mimeType
        }
        thumbnailUrl
        advertiser {
          ...CompanyFields
        }
        commercialSupervisor {
          ...UserFields
        }
        department {
          id
          name
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`
